import RadioButtonGroup, { DynamicRadioButtonGroup } from "@client/controls/Inputs/RadioButtonGroup/component";
import { type i18n, type WithOnChange } from "@client/types";
import { type Validation } from "@common/controls/Form/component";
import FormFieldCommon, {
  type FormComponentBaseProps,
  type FormFieldProps as FormFieldPropsCommon,
  type FormFieldValidateOn
} from "@common/controls/Form/Field/component";
import * as React from "react";

type ComponentProps = WithOnChange<any> & {
  isDisabled?: boolean;
  onBlur?: () => void;
};

export type FormFieldComponent = React.ComponentType<ComponentProps> & {
  getFinalValue?: () => Promise<any>;
};

export interface ClientFormFieldProps {
  addon?: any;
  className: string;
  colSpan?: number | null;
  Component: FormFieldComponent;
  componentOpts?: any;
  defaultValue?: any;
  error?: string | null;
  help?: string;
  i18n?: i18n;
  isDisabled?: boolean;
  isNoStyle?: boolean;
  isPaddingOnContainer?: boolean;
  isRequired?: boolean;
  label: string;
  name: string;
  showStar?: boolean;
  validation?: Validation;
  validateOn?: FormFieldValidateOn;
  value: any;
  width?: string;
  hint?: string | null;
  qa?: string;

  onChange: (name: string, value: any) => any;
}

const ClientFormField = ({ Component, componentOpts, help, validation, error, ...props }: ClientFormFieldProps) => (
  <FormField
    {...props}
    errorMessage={error}
    Component={Component as React.ComponentType<FormComponentBaseProps>}
    componentProps={componentOpts}
    tooltip={help}
    validator={validation}
  />
);

export default ClientFormField;

export type FormFieldProps<TValue, TProps extends FormComponentBaseProps> = Omit<
  FormFieldPropsCommon<TValue, TProps>,
  "isTrueRequired"
>;
export const FormField = <TValue, TProps extends FormComponentBaseProps>(props: FormFieldProps<TValue, TProps>) => (
  <FormFieldCommon
    {...props}
    isNoStyle={
      props.isNoStyle ||
      (props.Component as any) === RadioButtonGroup ||
      (props.Component as any) === DynamicRadioButtonGroup
    }
  />
);
